import { render, staticRenderFns } from "./BorderedDivComponent.vue?vue&type=template&id=6cdb427d"
import script from "./BorderedDivComponent.vue?vue&type=script&lang=js"
export * from "./BorderedDivComponent.vue?vue&type=script&lang=js"
import style0 from "./BorderedDivComponent.vue?vue&type=style&index=0&id=6cdb427d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports